import {z} from "zod/v4-mini"
import {TextureType} from "#material/types/texture"

export const resolvedTextureRevisionSchema = z.object({
    dataObjectId: z.string(),
    displacementCm: z.optional(z.number()),
    heightCm: z.number(),
    id: z.optional(z.string()),
    legacyId: z.optional(z.number()),
    widthCm: z.number(),
    dataObjectLegacyId: z.number(),
    textureType: z.nativeEnum(TextureType),
})
export const textureRevisionResolverSchema = z.any()
export const textureRevisionLegacyResolverSchema = z.any()

export type ResolvedTextureRevision = {
    dataObjectId: string
    dataObjectLegacyId: number
    displacementCm?: number
    heightCm: number
    id?: string
    legacyId?: number
    textureType: TextureType
    widthCm: number
}
export type TextureRevisionResolver = (input: string) => Promise<ResolvedTextureRevision>
export type TextureRevisionLegacyResolver = (input: number) => Promise<ResolvedTextureRevision>
